import axios from "axios";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const Form = ({ onSkip }) => {
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    phone: "",
    email: "",
    degree: "",
    current_job: "",
    political_team: "",
    join_ask: "",
    join_team: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData?.join_ask) {
        const checkEmailURL = `https://www.tanaghomtech.com/multaqa/public/api/member/checkemail?email=${formData.email}`;
        const res = await axios.get(checkEmailURL);

        if (res.data.data === "ok") {
          const data = new FormData();
          Object.keys(formData).forEach((key) =>
            data.append(key, formData[key])
          );

          await axios.post(
            "https://www.tanaghomtech.com/multaqa/public/api/member",
            data
          );
          toast.success("تم ارسال الطلب");
          setFormData({
            name: "",
            location: "",
            phone: "",
            email: "",
            degree: "",
            current_job: "",
            political_team: "",
            join_ask: "",
            join_team: "",
          });
        } else {
          toast.error("هذا الايميل موجود مسبقا");
        }
      } else {
        toast.error("اكمل تعبئة الحقول");
      }
    } catch (error) {
      toast.error("حدث خطأ، يرجى إعادة المحاولة");
    }
  };

  const handleSkip = (e) => {
    e.preventDefault(); // Prevent default link behavior
    localStorage.setItem("skip", "true"); // Mark form as skipped
    onSkip(); // Update state in Home.js
  };

  return (
    <section className="get-in-touch">
      <ToastContainer />
      <h1 className="title">
        ملتقى القوى الوطنية{" "}
        <div style={{ marginTop: "30px" }}>الديموقراطية الأول</div>
      </h1>
      <h4 className="title2">طلب انضمام</h4>
      <form className="contact-form row" onSubmit={handleSubmit}>
        {[
          "name",
          "location",
          "phone",
          "email",
          "degree",
          "current_job",
          "political_team",
        ].map((field) => (
          <div
            key={field}
            className={`form-field col-lg-${field === "notes" ? "12" : "6"}`}
          >
            <label className="label" htmlFor={field}>
              {field === "email"
                ? "البريد الالكتروني"
                : field === "name"
                ? "الاسم"
                : field === "location"
                ? " مكان الاقامة"
                : field === "phone"
                ? "رقم الهاتف متضمنا واتساب مع الرمز الدولي"
                : field === "degree"
                ? "الدرجة العلمية"
                : field === "current_job"
                ? "مجال العمل الحالي"
                : field === "political_team"
                ? "الفريق السياسي الذي تنتمي إليه (يكتب الاسم بدقة حسب التعريف المستخدم للفريق)"
                : field === "join_ask"
                ? "هل ترغب بالمشاركة في العمل للمؤتمر"
                : field === "join_team"
                ? "في حال رغبتك بالمشاركة خلال المرحلة التحضيرية للمؤتمر، الرجاء اختيار الفريق الذي ترغب التواجد فيه"
                : ""}
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              id={field}
              className="input-text js-input"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              type={field === "email" ? "email" : "text"}
              required={[
                "name",
                "location",
                "phone",
                "email",
                "degree",
                "current_job",
                "political_team",
              ].includes(field)}
            />
          </div>
        ))}
        {["join_ask"].map((field) => (
          <div key={field} className="form-field col-lg-6">
            <div style={{ marginTop: "10px" }}>
              {" "}
              <label className="label" htmlFor={field}>
                {field === "join_ask"
                  ? "هل ترغب بالمشاركة في العمل للمؤتمر؟"
                  : "في حال رغبتك بالمشاركة خلال المرحلة التحضيرية، اختر الفريق الذي ترغب بالتواجد فيه"}
              </label>{" "}
              <span style={{ color: "red" }}>*</span>{" "}
            </div>
            {
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "10px",
                  flexDirection: "column",
                }}
              >
                <label>
                  <input
                    type="radio"
                    name={field}
                    value="1"
                    checked={formData[field] === "1"}
                    onChange={handleChange}
                  />
                  نعم
                </label>
                <label>
                  <input
                    type="radio"
                    name={field}
                    value="0"
                    checked={formData[field] === "0"}
                    onChange={handleChange}
                  />
                  لا
                </label>
              </div>
            }
          </div>
        ))}

        <div
          className="col-lg-12"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <button type="submit" className="button-82-pushable p-4">
            <span className="button-82-shadow"></span>
            <span className="button-82-edge"></span>
            <span className="button-82-front text">ارسال</span>
          </button>
          <a href="/home" style={{ color: "gray" }}>
            الانتقال الى موقع الملتقى
          </a>
        </div>
      </form>
    </section>
  );
};

export default Form;
